import { useEffect } from 'react';
import useRootAppStore from './use-root-app-store';
import useDownloadService from './use-download-service';
const useDownloadCenterPoolingInterval = (isIdle) => {
    const { ui } = useRootAppStore();
    const { setPoolingInterval } = useDownloadService();
    useEffect(() => {
        const drawerStateInterval = isIdle
            ? ui.downloadCenterNotificationPoolingIntervalSeconds
            : ui.downloadCenterPoolingIntervalSeconds;
        const interval = drawerStateInterval;
        setPoolingInterval(interval);
    }, [isIdle]);
};
export { useDownloadCenterPoolingInterval };
//# sourceMappingURL=use-download-center-pooling-interval.js.map